import React, { useEffect, useState } from "react";
import { createNonceStr, md5 } from "@/utils/utils";
import "./index.scss";
// import Header from '@/components/header'
import rightBtn from "@/assets/images/rightbtn.png";
import inviteImg from "@/assets/images/invite.jpg";
import hhinviteImg from "@/assets/images/hhinvite.jpg";
import shipinImg from "@/assets/images/shishiyinshipinyun.png";
import closeImg from "@/assets/images/close.png";

import { Toast } from "antd-mobile";

import ShareModal from "@/components/sharemodal";
import request from "@/utils/request";
import { getLocationSearch, rewardDesForArr } from "@/utils/utils";
import InviteAuth from "@/components/inviteauth";
// import { connect } from 'react-redux'
import { invActApi } from "@/api";
import config from "@/config";

//  reducer state映射到props
// const mapStateToProps = (state) => ({
//   invitep: state.getIn(['inviteReducer', 'invitep']),
//   getmoney: state.getIn(['inviteReducer', 'getmoney']),
//   //获取出行平台唯一的标识
//   tenant: state.getIn(['tenantReducer', 'tenant'])
// })
// //  reducer dispatch映射到props
// const mapDispatchToprops = (dispatch) => ({

// })
import { connect } from "react-redux";
const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});
const Invite = (props) => {
  //获取token
  let getToken = getLocationSearch().token;
  //loading
  let [loading, setLoading] = useState(true);
  //邀请人数
  let [invitep, setInvitep] = useState(0);
  //奖金
  let [getmoney, setGetmoney] = useState(0);
  //扫码连接
  let [QrCodeUrl, setQrCodeUrl] = useState();
  //邀请人图片的地址
  let [actUrl, setActUrl] = useState("");
  //被邀请人图片的地址
  let [actInviteePosterUrl, setActInviteePosterUrl] = useState("");
  //拿到每个出行平台的唯一标识符
  let cxname = props.tenant;
  let { history } = props;
  // 控制分享弹窗
  let [shareMState, setShareMState] = useState(false);
  const handleShowShareModal = () => {
    setShareMState(!shareMState);
  };
  // 控制视频播放
  let [videoUrl, setVideoUrl] = useState("");

  let [videoShow, setVideoShow] = useState(false);
  const handleShowVideo = () => {
    setVideoShow(!videoShow);
  };

  //邀请资格弹窗
  let [inviteauth, setInviteAuth] = useState(false);
  //邀请资格信息配置
  let [inviterCondition, setInviterCondition] = useState([]);
  //活动信息
  let [rewardDesc, setRewardDesc] = useState([]);
  //活动标题
  let [actTitle, setActTitle] = useState("");
  //活动详情
  let [actDetail, setActDetail] = useState("");
  // 邀请信息列表
  const handlegoInviteinfo = () => {
    history.push({
      pathname: `/inviteinfo/${invitep}/${getmoney}`,
    });
  };
  // 教学视频
  const handlegoInviteVideo = () => {
    history.push({
      pathname: `/inviteVideo/${encodeURIComponent(videoUrl)}`,
    });
  };
  //获取当前用户的邀请权限显示弹窗
  function getType(arr) {
    if (arr) {
      for (let i = 0, k = arr.length; i < k; i++) {
        //更改！
        if (!arr[i].ok) {
          setInviteAuth(true);
          return;
        }
      }
    }
  }
  useEffect(() => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android
    if (isAndroid) {
      // window.handleGoBack();//这里的.android是安卓那边定义的类,可以随便定义,但这里必须要跟安卓那边统一
      if (typeof window?.savePicture?.setTitle === "function") {
        window?.savePicture?.setTitle("邀请好友成为司机");
      }
    }
    window.document.title = "邀请好友成为司机";
    if (getToken) {
      //带Token签名
      let appKey = "app_h5";
      let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
      let timestamp = new Date().getTime();
      let random = createNonceStr();
      let token = getToken;
      let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
      let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
      // console.log(appKey,timestamp,random,sign,token)
      setLoading(true);
      Toast.loading("loading...", 0, () => {}, true);
      request
        .get(
          invActApi,
          {
            token: getToken,
          },
          {
            appKey: appKey,
            timestamp: timestamp,
            random: random,
            token: token,
            sign: sign,
          }
        )
        .then((data) => {
          if (data.data.data) {
            //拿到数据
            let { inviterNum, rewardAmount } = data.data.data.inviter;
            let { driverQrCodeUrl } = data.data.data;
            //设置邀请人数和奖金总数
            setInvitep(inviterNum);
            setGetmoney(rewardAmount);
            setQrCodeUrl(driverQrCodeUrl);
            if (data.data.data.actInfoVo) {
              // if (data.data.data.actInfoVo.inviterRewardType == 2) {
              //   //邀请人图片地址
              //   setActInviteePosterUrl(data.data.data.actInfoVo.actPosterUrl);
              //   //被邀请人图片地址
              //   setActUrl(
              //     data.data.data.actInfoVo.actInviteePosterUrl
              //   );
              // } else {
                 //邀请人图片地址
                 setActInviteePosterUrl(
                  data.data.data.actInfoVo.actInviteePosterUrl
                );
                //被邀请人图片地址
                setActUrl(data.data.data.actInfoVo.actPosterUrl);
              // }

              //活动标题
              setActTitle(data.data.data.actInfoVo.actTitle);
              //活动详情
              setActDetail(data.data.data.actInfoVo.actDetail);
              //教学视频
              setVideoUrl(data.data.data.actInfoVo.demoVideo);
            }

            //邀请资格
            if (
              !data.data.data.inviterCondition ||
              data.data.data.inviterCondition.length === 0
            ) {
              setInviteAuth(false);
            } else {
              getType(data.data.data.inviterCondition);
              setInviterCondition(data.data.data.inviterCondition);
            }
            //奖励说明
            if (data.data.data.rewardDesc) {
              setRewardDesc(rewardDesForArr(data.data.data.rewardDesc));
            }
            //
          }
          setLoading(false);
          Toast.hide();
        });
    }
    return () => {};
  }, [getToken]);
  return loading ? (
    <div className="video_box">
      {/* <div className='iframe_box' dangerouslySetInnerHTML={{ __html: videoUrl }} />
        <img className='close_video' src={closeImg} onClick={handleShowVideo} /> */}
    </div>
  ) : (
    <div className="invite__box">
      {/* <Header tit="邀请司机" /> */}
      <div className="invite-con__box">
        <div className="invite-info">
          <div className="invite-info-top">
            <div className="left">
              <i />
              <span>邀请记录</span>
            </div>

            {getmoney > 0 || invitep > 0 ? (
              <i className="right-btn" onClick={handlegoInviteinfo}>
                查看详情
                <img src={rightBtn} alt="" />
              </i>
            ) : (
              ""
            )}
          </div>
          <div className="invite-info-content">
            <div>
              <article>
                <span>
                  <em>{invitep}</em>人
                </span>
                <span>邀请人数</span>
              </article>
            </div>
            <div>
              <article>
                <span className="num">
                  <em>{getmoney / 100}</em>元
                </span>
                <span>获得奖励</span>
              </article>
            </div>
          </div>
        </div>
        {videoUrl ? (
          <div className="invite-tips" onClick={handlegoInviteVideo}>
            <img src={shipinImg} /> 如何邀请好友？点击查看视频教学
          </div>
        ) : null}

        <div
          className={
            videoUrl ? "invite-con__show" : "invite-con__show no_video"
          }
        >
          {actInviteePosterUrl ? (
            <img src={actInviteePosterUrl} alt="" />
          ) : (
            <img src={config.inviteImg} alt="" />
            // <img
            //   src={
            //     getLocationSearch().tenantTag === "tonggang"
            //       ? inviteImg
            //       : getLocationSearch().tenantTag === "henghao"
            //       ? hhinviteImg
            //       : getLocationSearch().tenantTag === "nineh"
            //       ? hhinviteImg
            //       : getLocationSearch().tenantTag === "qianxing"
            //       ? hhinviteImg
            //       : hhinviteImg
            //   }
            //   alt=""
            // />
          )}

          <h2>{actTitle}</h2>
          <h3>{actDetail}</h3>
          <p>
            {rewardDesc.map((item, index) => (
              <em key={index}>{item}</em>
            ))}
          </p>
        </div>
      </div>
      <footer>
        <button
          onClick={handleShowShareModal}
          style={React.colorConfig ? React.colorConfig.buttonBg : {}}
        >
          立即邀请
        </button>
      </footer>
      <ShareModal
        shareMState={shareMState}
        handleShowShareModal={handleShowShareModal}
        QrCodeUrl={QrCodeUrl ? QrCodeUrl : ""}
        cxname={cxname}
        actUrl={actUrl}
      />
      {inviteauth ? (
        <InviteAuth
          setInviteAuth={setInviteAuth}
          inviterCondition={inviterCondition}
          invitep={invitep}
          getmoney={getmoney}
        />
      ) : (
        ""
      )}
    </div>
  );
};
export default connect(mapStateToProps)(Invite);

// import React from 'react'
// import './index.scss'
// import TgInvite from '@/views/tgchuxing/invite'
// import HhInvite from '@/views/hhchuxing/hhinvite'
// const Invite = (props) => {
//   let hostName = window.location.hostname
//   return (
//     <div className="invite__box__box">
//       {/*  */}
//       {
//         hostName === 'localhost' ? <TgInvite {...props}/> : ( hostName === '192.168.39.70' ? <HhInvite {...props}/> : '')
//       }

//     </div>
//   )
// }
// export default Invite
